import React from 'react';
import { Chip } from '@material-ui/core';

const RMSChip = React.forwardRef(
  (
    {
      label,
      color = 'primary',
      shape = 'round',
      size = 'small',
      variant = 'default',
      icon,
      avatar,
      disabled = false,
      clickable = false,
      onClick,
      onDelete,
      className = '',
      ...rest
    },
    ref
  ) => {
    const muiColor = ['default', 'primary', 'secondary'].includes(color) ? color : 'default';

    const classes = [
      'rms-chip',
      `rms-chip--${shape}`,
      `rms-chip--${variant}`,
      `rms-chip--${color}`,
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <Chip
        ref={ref}
        label={label}
        icon={icon}
        avatar={avatar}
        size={size}
        variant={variant}
        disabled={disabled}
        clickable={clickable || Boolean(onClick)}
        color={muiColor}
        onClick={onClick}
        onDelete={onDelete}
        className={classes}
        {...rest}
      />
    );
  }
);

RMSChip.displayName = 'RMSChip';

export default RMSChip;

/**
 * RMSChip
 *
 * Props
 *
 *
 * label       : ReactNode
 * color       : "default"
 *             | "primary"
 *             | "secondary"
 *             | "success"
 *             | "error"
 *             | "warning"
 *             | "info"
 *
 * shape       : "round" | "square"
 * size        : "small" | "medium"
 * variant     : "default" | "outlined"
 * icon        : ReactNode
 * avatar      : ReactNode
 * disabled    : true | false
 * clickable   : true | false
 * onClick     : () => {}
 * onDelete     : () => {}
 *                Called when the delete icon is clicked.
 * className   : string
 *
 * Usage
 *
 * <RMSChip label="Default" />
 *
 * <RMSChip
 *   label="Primary"
 *   color="primary"/>
 *
 * /** */